import styled from 'styled-components';

interface ECoachSectionProps {
  hidden?: boolean;
  paddingSize?: 'large' | 'none';
}

export const Section = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`;

// Simplified padding approach with discrete sizes
export const ECoachSection = styled(Section)<ECoachSectionProps>`
  display: ${(props) =>
    props.hidden?.toString() === 'true' ? 'none' : 'flex'};
  padding-right: ${(props) => {
    switch (props.paddingSize) {
      case 'large':
        return '20%';
      case 'none':
        return '0';
      default:
        return '20%';
    }
  }};
`;

export const UserSection = styled(Section)<ECoachSectionProps>`
  align-items: flex-end;
  display: flex;
  padding-left: ${(props) => {
    switch (props.paddingSize) {
      case 'large':
        return '20%';
      case 'none':
        return '0';
      default:
        return '20%';
    }
  }};
`;
